import { useEffect, useState } from 'libs/react';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { Closeable } from 'components/util/Closeable';
import { Button } from './Button';
import './AdditionalInformationButton.scss';
/**
 * @component AdditionialInformationButton
 * @since 1.0.0
 * @hidden
 */
export function AdditionialInformationButton(props) {
    const { onAdditionalInformationFilterApply, additionalInformationFilteredArray, defaultAdditionalInformationFilteredIds, additionalInformationFilteredIds } = props;
    const [opened, setOpened] = useState(false);
    const [selectedIds, setSelectedIds] = useState(additionalInformationFilteredIds);
    /**
     * @function onToggle
     * @since 1.0.0
     */
    const onToggle = () => {
        setOpened(!opened);
    };
    /**
     * @function onClose
     * @since 1.0.0
     */
    const onClose = () => {
        setOpened(false);
    };
    const onApply = () => {
        onAdditionalInformationFilterApply(selectedIds);
        setOpened(false);
    };
    const onCheckboxChange = (e, id) => {
        if (e.currentTarget.checked) {
            setSelectedIds([...selectedIds, id]);
        }
        else {
            setSelectedIds(selectedIds.filter((value) => value !== id));
        }
    };
    useEffect(() => {
        setSelectedIds(additionalInformationFilteredIds);
    }, [additionalInformationFilteredIds]);
    return (React.createElement(Closeable, { onClose: onClose },
        React.createElement("div", null,
            React.createElement(Button, { className: "additional-information-button", label: t('Additional Information Shown'), badge: React.createElement(Text, { value: selectedIds.length }), onPress: onToggle }),
            opened && (React.createElement("div", { className: "additional-information-button-container" },
                React.createElement("div", { className: "additional-information-button-header" },
                    React.createElement("div", null,
                        React.createElement(Button, { picto: "check", label: t('Select All'), style: "plain", onPress: () => setSelectedIds(defaultAdditionalInformationFilteredIds) }),
                        React.createElement(Button, { picto: "xmark", label: t('Uncheck All'), style: "plain", onPress: () => setSelectedIds([]) })),
                    React.createElement(Button, { label: t('Apply'), style: "primary", onPress: onApply })),
                React.createElement("div", { className: "additional-information-button-body" }, additionalInformationFilteredArray === null || additionalInformationFilteredArray === void 0 ? void 0 : additionalInformationFilteredArray.map((value) => {
                    const checked = selectedIds.includes(value.id);
                    return (React.createElement("div", { key: value.id },
                        React.createElement("input", { id: `unifiedField-${value.id}`, type: "checkbox", checked: checked, onChange: (e) => onCheckboxChange(e, value.id) }),
                        React.createElement("label", { htmlFor: `unifiedField-${value.id}` }, value.title)));
                })))))));
}
